import { baseApi } from '@/services/index';

const resource = process.env.VUE_APP_RESOURCE_SICUDGPD_PR_EST;

export default {
  post(payload) {
    return baseApi.post(resource, payload);
  },
};
